import React, { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePassword = ({ compact = false }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const err = f.next && f.next.length < 8 ? "At least 8 characters" : f.confirm && f.next !== f.confirm ? "Passwords do not match" : "";

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      if (data.token) localStorage.setItem("lac_token", data.token);
      toast.success("Password changed");
      setF(EMPTY); setOpen(false);
    } catch (e2) { toast.error(formatError(e2)); } finally { setBusy(false); }
  };

  const field = (k, label, testid) => (
    <div>
      <Label>{label}</Label>
      <Input data-testid={testid} type="password" autoComplete={k === "current" ? "current-password" : "new-password"}
             value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="bg-slate-950 border-slate-700" />
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setF(EMPTY); }}>
      <DialogTrigger asChild>
        {compact ? (
          <button data-testid="mobile-button-change-password" aria-label="Change password"
                  className="md:hidden p-2 rounded-md text-sky-300 border border-slate-700 hover:bg-slate-800 transition-colors">
            <KeyRound size={14} />
          </button>
        ) : (
          <Button data-testid="button-change-password" size="sm" variant="outline"
                  className="w-full mt-3 border-slate-700 hover:bg-slate-800 text-slate-100">
            <KeyRound size={14} className="mr-2" /> Change password
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="bg-slate-900 border-slate-800 text-slate-100 max-w-md">
        <DialogHeader><DialogTitle className="font-display text-2xl">Change password</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          {field("current", "Current password", "input-current-password")}
          {field("next", "New password", "input-new-password")}
          {field("confirm", "Confirm new password", "input-confirm-password")}
          {err && <div data-testid="change-password-error" className="text-xs text-rose-300">{err}</div>}
          <Button data-testid="button-save-password" type="submit" disabled={busy || !f.current || !f.next || !!err || f.next !== f.confirm}
                  className="w-full bg-blue-600 hover:bg-blue-500">
            {busy && <Loader2 size={14} className="mr-2 animate-spin" />} Save new password
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
